import React, { useState } from "react";
import axios from "axios";
import {
	Row,
	Col,
	Typography,
	Upload,
	Image,
	Button,
	Modal,
	message,
	Spin,
} from "antd";
import { EditFilled } from "@ant-design/icons";
import { HiPlusCircle } from "react-icons/hi";
import { Shimmer } from "components/Shimmer";

const { Title } = Typography;

function getBase64(img, callback) {
	const reader = new FileReader();
	reader.addEventListener("load", () => callback(reader.result));
	reader.readAsDataURL(img);
}

export default function ImageField({
	src,
	updateText,
	fieldId,
	width,
	height,
	banner
}) {
	const [showModal, toggleModal] = useState(false);
	const [tempPhotoSrc, setTempPhotoSrc] = useState();
	const [filePreview, setFilePreview] = useState();
	const [fileList, setFileList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [finalSrc, setFinalSrc] = useState(src);
	const [firstTime, setFirstTime] = useState(true);


	const handleConfirmUpload = () => {
		updateText({ fieldId, fieldValue: tempPhotoSrc }, () => {
			setFinalSrc(tempPhotoSrc);
			toggleModal(false);
			setFirstTime(false);
		});
	};

	const renderButtons = () => {
		return (
			<Row
				align="bottom"
				style={{
					justifyContent: "space-between",
					marginTop: "1rem",
					marginBottom: "1rem",
				}}
			>
				<Button
					size="large"
					style={{
						color: "#4F5655",
						backgroundColor: "white",
						border: "1px solid #CDCFCE",
						borderRadius: 4,
						width: 200,
					}}
					onClick={() => toggleModal(false)}
				>
					Cancel
				</Button>
				<Button
					size="large"
					style={{
						color: "white",
						backgroundColor: !tempPhotoSrc || loading ? "#646666" : "#363E3D",
						border: "1px solid white",
						borderRadius: 4,
						width: 200,
					}}
					disabled={!tempPhotoSrc || loading}
					onClick={handleConfirmUpload}
				>
					{!firstTime ? "Replace and upload" : "Confirm and upload"}
				</Button>
			</Row>
		);
	};

	function beforeUpload(file) {
		const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
		if (!isJpgOrPng) {
			message.error("You can only upload JPG/PNG file!");
		}
		return isJpgOrPng;
	}

	const customRequest = async (options) => {
		const { file } = options;

		const fmData = new FormData();
		const config = {
			headers: { "content-type": "multipart/form-data" },
		};

		fmData.append("image", file);

		axios
			.post(process.env.REACT_APP_ARTIFACTS, fmData, config)
			.then((response) => {
				if (response.status === 200) {
					getBase64(file, (imageUrl) => {
						setFilePreview(imageUrl);
						setLoading(false);
					});
					setTempPhotoSrc(response.data?.data?.id);
				}
			})
			.catch((err) => {
				setLoading(false);
				message.error("Uploading failed. Select an image again");
			});
	};

	const handleChangeUpload = (info) => {
		setLoading(true);
		let fileList = [...info.fileList];
		fileList = fileList.slice(-1);
		setFileList(fileList);
	};

	const renderNoImage = () => {
		return (
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					cursor: "pointer",
					overflow: "hidden",
				}}
			>
				<div
					style={{
						textAlign: "center",
						color: "#1D2624",
					}}
				>
					<HiPlusCircle size={45} color="#B4B7B6" />
				</div>

				<div
					style={{
						fontSize: 16,
						marginBottom: "1rem",
						textAlign: "center",
						color: "#1D2624",
					}}
				>
					Drag or click to browse
				</div>
				<div style={{ fontSize: 14, textAlign: "center", color: "#4F5655" }}>
					{`We recommend you to add jpg or png files with ${width} x ${height} px dimensions`}
				</div>
			</div>
		);
	};

	const renderWithImage = () => {
		return (
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					borderRadius: 8,
					height: "50vh",
					overflow: "hidden",
					width: "100%",
					cursor: "pointer",
				}}
			>
				<Image
					onClick={() => {}}
					preview={false}
					height="100%"
					width="100%"
					style={{ overflow: "hidden" }}
					alt="prodcuts"
					src={filePreview}
				/>
			</div>
		);
	};

	const renderUpload = () => {
		return (
			<Upload
				fileList={fileList}
				customRequest={customRequest}
				beforeUpload={beforeUpload}
				onChange={handleChangeUpload}
				showUploadList={false}
			>
				{loading ? <Spin /> : filePreview ? renderWithImage() : renderNoImage()}
			</Upload>
		);
	};

	return (
		<>
			<div
				style={{
					borderRadius: "0.5rem",
					position: "relative",
					backgroundColor: "#F5F5F5",
					height: 170,
				}}
			>
				<Image
					preview={false}
					height={"100%"}
					width={"100%"}
					alt="prodcuts"
					src={`${process.env.REACT_APP_DIRECTUS}assets/${finalSrc}?transforms=[["resize",{"width":${width},"height":${height},"fit":"contain","background":"white"}]]`}
					placeholder={<Shimmer style={{ width: "100%", height: "100%" }} />}
				/>
				<div
					onClick={() => toggleModal(true)}
					style={{
						cursor: "pointer",
						borderRadius: "0.5rem",
						right: -3,
						bottom: -3,
						boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
						position: "absolute",
						backgroundColor: "white",
						height: "2.5rem",
						width: "2.5rem",
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
					}}
				>
					<EditFilled style={{ color: "#686E6D" }} />
				</div>
			</div>
			<Modal
				width={"120vh"}
				visible={showModal}
				footer={null}
				onCancel={() => toggleModal(false)}
				bodyStyle={{ padding: "2rem" }}
			>
				<Title level={4} bold>
					Upload {fieldId }
				</Title>
				<Col
					span={24}
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						borderRadius: 8,

						marginTop: "2rem",
						marginBottom: "2rem",
						height: "50vh",
						border: filePreview ? "0px" : "1px dashed #CDCFCE",
						padding: filePreview ? 0 : "3rem",
					}}
				>
					{renderUpload()}
				</Col>
				{renderButtons()}
			</Modal>
		</>
	);
}
